import Model from "./base/model";

class SimulationTableTde extends Model{
  resourceName() {
    return "simulation_table_tde";
  }

  fields() {
    return {
      simulation_table_id: "",
      city_id: "",
      city: "",
      cnpj_cpf: "",
      social_reason: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableTde();
